import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';

export default {
  sliderContainer: {
    width: ['100%', '100%', '100%', '100%', 'calc(100% - 25.5555556vw)', 'calc(100% - 25.1041667vw)'],
    display: 'flex',
    position: 'relative',
    height: '100%',
    '.swiper-slide': {
      width: ['84.5333333vw', '84.5333333vw', '26.5625vw', '26.5625vw', '22.7777778vw', '22.6041667vw'],
      padding: '4 px 0',
      a: {
        '&:focus-visible': {
          position: 'relative',
          display: 'block',
        },
      },
    },
    '.swiper-wrapper': {
      transitionTimingFunction: 'linear !important',
      display: 'flex',
    },
  },
  slideStyles: {
    position: 'relative',
    height: ['138.666667vw', '138.666667vw', '43.6197917vw', '43.6197917vw', '36.6666667vw', '37.7083333vw'],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    h4: {
      whiteSpace: 'nowrap',
      textAlign: 'center',
    },
    img: {
      transition: 'opacity .15s',
    },
    '.hoverOverlap': {
      background: theme.rawColors.neutralBlack,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: theme.zIndex.documentUp,
      opacity: 0,
      ...reusables.mainTransition('opacity', theme.transitions.animation.atomCurve, theme.transitions.time.fast),
    },
    '&:hover': {
      '.hoverOverlap': {
        opacity: 0.2,
      },
    },
  },
  packshotImageWrapper: {
    position: 'relative',
    flexShrink: 0,
    width: ['71.7333333vw', '71.7333333vw', '20.3125vw', '20.3125vw', '18.4375vw'],
    height: ['84.8vw', '84.8vw', '16.015625vw', '16.015625vw', '18.4375vw'],
    mb: 40,
  },
  imageSlide: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  sliderTitle: (colorTitle: string, isPackshot: boolean) => ({
    position: isPackshot ? 'static' : 'absolute',
    bottom: ['54px', '54px', '90px'],
    left: '50%',
    textTransform: 'uppercase',
    transform: !isPackshot ? 'translateX(-50%)' : 'none',
    zIndex: theme.zIndex.documentHigh,
    textAlign: 'center',
    color: colorTitle || theme.rawColors.neutralWhite,
    lineHeight: '54px',
  }),
};
